import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-7e5afc98"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "background"
};
const _hoisted_2 = {
  class: "main"
};
const _hoisted_3 = {
  class: "top-back"
};
const _hoisted_4 = {
  class: "icon-main"
};
const _hoisted_5 = ["src"];

const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 漂流瓶交友 ");

const _hoisted_7 = {
  class: "right-title"
};
const _hoisted_8 = {
  class: "mid-back"
};
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  class: "left-back"
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "mid-title"
}, "漂流瓶交友", -1));

const _hoisted_12 = {
  class: "word-img"
};
const _hoisted_13 = ["src"];
const _hoisted_14 = ["src"];
const _hoisted_15 = {
  class: "btn-back"
};
const _hoisted_16 = {
  class: "qrback"
};
const _hoisted_17 = ["src"];
const _hoisted_18 = {
  class: "beian-top"
};

const _hoisted_19 = /*#__PURE__*/_createTextVNode("网站备案/许可证号：");

const _hoisted_20 = {
  class: "beian-link",
  target: "_blank",
  href: "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010602012208"
};
const _hoisted_21 = ["src"];

const _hoisted_22 = /*#__PURE__*/_createTextVNode("粤公网安备44010602012208号");

const _hoisted_23 = /*#__PURE__*/_createTextVNode("   网站备案/许可证号：");

const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "beian-link",
  target: "_blank",
  href: "https://beian.miit.gov.cn/"
}, "粤ICP备2023147598号-1", -1));

const _hoisted_25 = {
  class: "beian"
};

const _hoisted_26 = /*#__PURE__*/_createTextVNode("违法和不良信息举报邮箱：piaoliupingjiaoyou@163.com   公司名称：");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_contact_tip = _resolveComponent("contact-tip");

  const _component_contact_change = _resolveComponent("contact-change");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
    src: $setup.quan,
    class: "icon"
  }, null, 8, _hoisted_5), _hoisted_6]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.tips.showTip && $setup.tips.showTip(...args)),
    class: "content-word"
  }, "联系我们")])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("img", {
    src: $setup.rightimg,
    class: "rightimg"
  }, null, 8, _hoisted_9), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("div", _hoisted_12, [_createElementVNode("img", {
    src: $setup.word,
    class: "left-word"
  }, null, 8, _hoisted_13), _createElementVNode("img", {
    src: $setup.word1,
    class: "big-word"
  }, null, 8, _hoisted_14)]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", {
    class: "down-btn",
    onClick: _cache[1] || (_cache[1] = (...args) => $setup.downloadAndroid && $setup.downloadAndroid(...args))
  }, "Android下载"), _createElementVNode("div", _hoisted_16, [_createElementVNode("img", {
    src: $setup.qrcode,
    class: _normalizeClass({
      'qrcode': true,
      'bigImg': $setup.big
    })
  }, null, 10, _hoisted_17)])])])]), _createElementVNode("div", _hoisted_18, [_hoisted_19, _createElementVNode("a", _hoisted_20, [_createElementVNode("img", {
    class: "beian-img",
    src: $setup.beian
  }, null, 8, _hoisted_21), _hoisted_22]), _hoisted_23, _hoisted_24]), _createElementVNode("div", _hoisted_25, [_hoisted_26, _createElementVNode("a", {
    href: "javascript:;",
    onClick: _cache[2] || (_cache[2] = (...args) => $setup.tips.showTip && $setup.tips.showTip(...args)),
    class: "names"
  }, "广州鑫盛计算机科技有限公司")])]), _createVNode(_component_contact_tip, {
    ref: "tips"
  }, null, 512), _createVNode(_component_contact_change, {
    ref: "change"
  }, null, 512), _withDirectives(_createElementVNode("div", {
    class: "back",
    onClick: _cache[3] || (_cache[3] = (...args) => $setup.bigImg && $setup.bigImg(...args))
  }, null, 512), [[_vShow, $setup.big]]), _withDirectives(_createElementVNode("div", {
    onClick: _cache[4] || (_cache[4] = (...args) => $setup.bigImg && $setup.bigImg(...args)),
    class: "code-title"
  }, "扫描二维码下载", 512), [[_vShow, $setup.big]])]);
}